import { TFunction } from "i18next";
import moment from "moment";

export const formatDurationForMeetingDescription = (
  durationInMin: number,
  t: TFunction,
  locale = "en"
): string => {
  const hours = Math.floor(durationInMin / 60);

  const hourString = t("ROOSTER.PUBLIC-APP.HOUR", {
    defaultValue: "hour"
  });

  const hoursString = t("ROOSTER.PUBLIC-APP.HOURS", {
    defaultValue: "hours"
  });

  const minuteString = t("ROOSTER.PUBLIC-APP.MINUTE", {
    defaultValue: "minute"
  });

  const minutesString = t("ROOSTER.PUBLIC-APP.MINUTES", {
    defaultValue: "minutes"
  });

  if (hours === 0) {
    return moment()
      .startOf("day")
      .add(durationInMin, "minutes")
      .locale(locale)
      .format(`m [${durationInMin === 1 ? minuteString : minutesString}]`);
  }

  const minutes = durationInMin % 60;
  const timeFormat =
    minutes > 0
      ? `h [${hours === 1 ? hourString : hoursString}] m [${minutes === 1 ? minuteString : minutesString}]`
      : `h [${hours === 1 ? hourString : hoursString}]`;
  return moment()
    .startOf("day")
    .add(durationInMin, "minutes")
    .locale(locale)
    .format(timeFormat);
};
